<footer>
  <div class="top-part">
    <div class="info">
      <h2 class="title">{{ 'CORE.COMPONENTS.FOOTER.TOP.INFO.HEADER' | translate }}</h2>
      <div>{{ 'CORE.COMPONENTS.FOOTER.TOP.INFO.TEXT' | translate }}</div>
    </div>
    <div class="footer-navigation">
      <h2 class="title">{{ 'CORE.COMPONENTS.FOOTER.TOP.NAVIGATION.HEADER' | translate }}</h2>
      <div class="links-wrapper">
        <div class="left-list">
          <a class="footer-link" routerLink="/opening-hours">{{
            'CORE.COMPONENTS.FOOTER.TOP.NAVIGATION.LINKS.OPENING-HOURS' | translate
          }}</a>
          <a class="footer-link" routerLink="/support">{{
            'CORE.COMPONENTS.FOOTER.TOP.NAVIGATION.LINKS.CUSTOMER-SUPPORT' | translate
          }}</a>
          <a class="footer-link" routerLink="/support/faq">{{
            'CORE.COMPONENTS.FOOTER.TOP.NAVIGATION.LINKS.QUESTIONS-ANSWERS' | translate
          }}</a>
          <a
            class="footer-link"
            href="https://uustatus.no/nb/erklaringer/publisert/4c1e9d13-2ba2-433c-be3b-8b1aa707b9dc"
            target="_blank"
            appExternalLink
            >{{ 'CORE.COMPONENTS.FOOTER.TOP.NAVIGATION.LINKS.ACCESSIBILITY-STATEMENT' | translate | hyphenate }}</a
          >
          <a class="footer-link" routerLink="/improve-hse-card-solution">{{
            'CORE.COMPONENTS.FOOTER.TOP.NAVIGATION.LINKS.IMPROVE-HSE-CARD-SOLUTION' | translate
          }}</a>
        </div>
        <div class="right-list">
          <a class="footer-link" routerLink="/sitemap" href="">{{
            'CORE.COMPONENTS.FOOTER.TOP.NAVIGATION.LINKS.SITEMAP' | translate
          }}</a>
          <a class="footer-link" routerLink="/for-developers">{{
            'CORE.COMPONENTS.FOOTER.TOP.NAVIGATION.LINKS.FOR-DEVELOPERS' | translate
          }}</a>
          <a class="footer-link" routerLink="/privacy-and-cookies">{{
            'CORE.COMPONENTS.FOOTER.TOP.NAVIGATION.LINKS.PRIVACY-STATEMENT' | translate | hyphenate
          }}</a>
          <a class="footer-link" routerLink="/terms-of-use">{{
            'CORE.COMPONENTS.FOOTER.TOP.NAVIGATION.LINKS.TERMS-OF-USE' | translate
          }}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-part">
    <div class="logo-block">
      <picture>
        <source srcset="/images/footer-logo.webp" type="image/webp" />
        <img
          src="/images/footer-logo.png"
          alt="{{ 'ARIA-LABELS.LOGO-FOOTER' | translate }}"
          loading="lazy"
          width="217"
          height="55"
        />
      </picture>
    </div>
    <div class="rights-info-block">
      <div>{{ 'CORE.COMPONENTS.FOOTER.BOTTOM.INFO.TEXT-1' | translate }}</div>
      <div>
        © <span>{{ currentYear }}</span>
        {{ 'CORE.COMPONENTS.FOOTER.BOTTOM.INFO.TEXT-2' | translate }}
      </div>
    </div>
  </div>
</footer>
